import { createContext, useReducer } from "react";
import { notification, NotiInicial } from "../Model/Notificacion";

export const NotificacionesGeneral=createContext<any>(NotiInicial);

const reducer=(state:any,action:any):notification[]=>
{
    return action.input;
}

export const NotiContextoLlamado=({children}:any)=>
{
    const [NotifiContext,dispatch]=useReducer(reducer,NotiInicial);

    const ActualizarNotificacion=(number:notification[])=>
    {
        dispatch({input:number})
    }

    return (
        <NotificacionesGeneral.Provider value={{NotifiContext,ActualizarNotificacion}}>
            {children}
        </NotificacionesGeneral.Provider>
    )
}